import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useLocalizedMoney = () => {
    const { i18n } = useTranslation();
    /**
     * i18nの言語とmomentのlocaleを結びつける
     */
    const localeDict: Record<string, string> = useMemo(
        () => ({
            ja: 'ja',
            en: 'en',
            vi: 'vi',
            ko: 'ko',
            'zh-TW': 'zh-tw',
            zh: 'zh-cn',
            th: 'th',
            id: 'id',
        }),
        [],
    );

    const currencyUnitDict: Record<string, Record<string, string>> = useMemo(
        () => ({
            JPY: {
                ja: '円',
                en: ' Yen',
                vi: ' Yên',
                ko: '엔',
                'zh-TW': '日圆',
                zh: '日元',
                th: 'เยน',
                id: ' yen',
            },
        }),
        [],
    );

    const currencyUnit = useCallback(
        (unitCode: string) => {
            const locale = i18n.language;
            switch (unitCode) {
                case 'JPY':
                    return currencyUnitDict.JPY[locale];
                default:
                    return '';
            }
        },
        [currencyUnitDict.JPY, i18n.language],
    );

    /**
     * i18nで指定した言語でお金をformatする。
     * @param {*} money お金情報
     * @returns
     */
    const formatMoney = useCallback(
        (money: any, currencyUnitCode?: string) => {
            if (typeof money !== 'number') {
                return '';
            }
            const locale = i18n.language;
            return (
                money.toLocaleString(localeDict[locale], { style: 'decimal' }) +
                `${currencyUnitCode ? currencyUnit(currencyUnitCode) : ''}`
            );
        },
        [currencyUnit, i18n.language, localeDict],
    );

    return { formatMoney, currencyUnit };
};

export default useLocalizedMoney;
